module.exports = __webpack_public_path__ + "static/media/Horace Slughorn 2.0433b11b.jpg";